import { useT } from "@/lib/i18n";
import { useAuth } from "@/lib/platform/AuthProvider";
import { useAppNavigation } from "@/lib/platform";

/**
 * "Already a member? Log in", shown in the dock's note slot on the first
 * screen only.
 *
 * It lives here rather than inside IntroScreen because the dock is shared
 * chrome owned by the shell — screens describe what goes in it, they don't
 * render it. Sign-in appears nowhere else in the flow: returning members need
 * it before they start answering, and a pill floating over the question
 * screens competes with the answers and covers the header.
 */
export default function DockLoginNote({ copyKey }: { copyKey: string }) {
  const { t } = useT();
  const { openSignIn } = useAuth();
  const { navigate } = useAppNavigation();

  return (
    <span>
      {t(`${copyKey}.hasAccount`)}{" "}
      <button
        type="button"
        onClick={() => openSignIn({ onSuccess: () => navigate("/"), returnTo: "/" })}
        className="font-semibold text-primary-400 underline underline-offset-2"
      >
        {t(`${copyKey}.login`)}
      </button>
    </span>
  );
}
